// TEMPORARY HOME. Per epic decisions #7 and #8 these belong in `@onward-delivery/core`, but that is
// a published package -- a version bump and release cycle. Move them once the vocabularies settle.

// Broad freight categories for the profile (multi-select) -- its own vocabulary, deliberately not the item-level
// ITEM_TYPES list. It adds Pallets (a freight type, not an item type) and folds
// doors / windows / carpets into Building Materials. `other` is the catch-all; no "All" option
// (decision #6). `pallet` reuses the FREIGHT_TYPES code. Must stay in sync with
// delivery_profiles_commodity_check.
export const COMMODITY_OPTIONS = [
    { value: 'furniture', label: 'Furniture' },
    { value: 'mattress', label: 'Mattresses' },
    { value: 'appliance', label: 'Appliances' },
    { value: 'exerciseEquipment', label: 'Exercise Equipment' },
    { value: 'pallet', label: 'Pallets' },
    { value: 'cabinets', label: 'Cabinets' },
    { value: 'buildingMaterials', label: 'Building Materials' },
    { value: 'other', label: 'Other' },
];

// A fifth vocabulary, not one of the four that exist: none of those splits white glove by assembly
// (today assembly is an orthogonal axis). Must stay in sync with delivery_profiles_delivery_types_check.
export const PROFILE_DELIVERY_TYPES = [
    { value: 'curbside', label: 'Curbside' },
    { value: 'firstDrySpace', label: 'First Dry Space' },
    { value: 'roomOfChoice', label: 'Room of Choice' },
    { value: 'whiteGloveNoAssembly', label: 'White Glove, No Assembly' },
    { value: 'whiteGloveAssembly', label: 'White Glove, Assembly' },
];

// Descriptive only (decision #8): these do not filter carriers and do not affect price.
// Haul-away and Bed Frame Assembly are the agreed V1 starting set (decision #8), not placeholders;
// the list grows as the master list lands.
// `value` is a stable code kept separate from `label` so a future billing join survives copy changes.
export const SPECIAL_REQUIREMENTS = [
    { value: 'haulAway', label: 'Haul-away' },
    { value: 'bedFrameAssembly', label: 'Bed Frame Assembly' },
];

// PROVISIONAL -- the commodity -> requirement mapping stands in for "Sean and Colin's master list",
// which we do not have yet. Update it when that list lands.
// A profile offers the union of its commodities' requirements. While every commodity maps to at
// least haulAway, the modal's "No special requirements apply to these commodities." branch is
// unreachable -- recheck it once the real mapping is in.
export const COMMODITY_SPECIAL_REQUIREMENTS = {
    furniture: ['haulAway'],
    mattress: ['haulAway', 'bedFrameAssembly'],
    appliance: ['haulAway'],
    exerciseEquipment: ['haulAway'],
    pallet: ['haulAway'],
    cabinets: ['haulAway'],
    buildingMaterials: ['haulAway'],
    other: ['haulAway'],
};
